export const AUFGABENGRUPPE_DESTINATION_YIELD = 'DestinationYield';
export const AUFGABENGRUPPE_RELEASEPROZESS = 'Releaseprozess';
export const AUFGABENGRUPPE_REPRU = 'Repru';
